module.exports = __webpack_public_path__ + "img/fb.a28033c3.svg";